// extracted by mini-css-extract-plugin
export default {"Box":"table-group-module__Box--jGoWp","isOver":"table-group-module__isOver--WV05e"};